export const toastVisible = state => state.toastVisible

export const toastMessage = state => state.toastMessage

export const toastState = state => state.toastState

export const reportData = state => state.reportData

export const noticeList = state => state.noticeList

export const basicMenuList = state => state.basicMenuList



// WEBPACK FOOTER //
// ./src/store/getters.js